import React, { Component } from 'react'
import { NameContainer } from '../../Commons/Name'
import { withTranslation } from 'react-i18next'
import PropTypes from "prop-types";

class Identity extends Component {

    static propTypes = {
        t: PropTypes.func.isRequired,
    }

    render()
    {
        const { t } = this.props

        return (
            <div>
                { t('visualizer:toolbar.left.collaborativeIndexationCreation.form.nominative_with_date.steps.identity.title') }
                <NameContainer hasFocus={true} />
            </div>
        )
    }
}

export default withTranslation()(Identity)
